export const DEFAULT_MAX_LENGTH = 27

export const tailTruncate = (
    string = '',
    desiredLength = DEFAULT_MAX_LENGTH,
    separator = '…',
) => {
    if (!string) {
        return ''
    }
    const sepLength = separator.length

    if (string.length <= desiredLength) {
        return string
    } else {
        return string.substr(0, desiredLength - sepLength) + separator
    }
}

export default function middleTruncate(
    string = '',
    desiredLength = DEFAULT_MAX_LENGTH,
    separator = '…',
) {
    if (string == null) {
        return ''
    }

    const sepLength = separator.length

    if (string.length <= desiredLength) {
        return string
    } else if (string.length > desiredLength) {
        if (desiredLength <= sepLength) {
            return string
        } else if (sepLength * 2 > desiredLength / 2) {
            return string
        }
    }

    const charsToShow = desiredLength - sepLength
    const frontChars = Math.ceil(charsToShow / 2)
    const backChars = Math.floor(charsToShow / 2)

    return (
        string.substr(0, frontChars) +
        separator +
        string.substr(string.length - backChars)
    )
}
